import SidebarNavigationOnboarding from 'onboarding/onboardings/SidebarNavigation/sidebarNavigationOnboarding';
import AllAccountsOnboarding from 'onboarding/onboardings/AllAccountsOnboarding/allAccountsOnboarding';
import ConnectionsOnboarding from 'onboarding/onboardings/ConnectionsOnboarding/connectionsOnboarding';
import {projectsService} from 'services';
import ProjectPlacementsOnboarding
  from 'onboarding/onboardings/ProjectPlacementsOnboarding/projectPlacementsOnboarding';
import ProjectsListCommonInfoOnboarding
  from 'onboarding/onboardings/ProjectsListCommonInfoOnboarding/projectsListCommonInfoOnboarding';


const MENU_ONBOARDINGS_LIST = [
  {
    title: 'Как ориентироваться в системе',
    onboarding: SidebarNavigationOnboarding,
    targetRoute: {
      name: 'home'
    }
  },
  {
    title: 'Как устроены аккаунты',
    onboarding: AllAccountsOnboarding,
    targetRoute: {
      name: 'home'
    }
  },
  {
    title: 'Как устроены проекты',
    onboarding: ProjectsListCommonInfoOnboarding,
    targetRoute (getters) {
      return {
        name: 'projectsList',
        params: {
          accountId: getters.accountIdWithProject
        }
      };
    },
    requiredParams: ['accountIdWithProject']
  },
  {
    title: 'Как добавить рекламные кампании',
    onboarding: ProjectPlacementsOnboarding,
    targetRoute (getters) {
      return {
        name: 'placementsList',
        params: {
          accountId: getters.accountIdWithProject,
          projectId: getters.accountProjectId
        }
      };
    },
    requiredParams: ['accountProjectId', 'accountIdWithProject']
  },
  {
    title: 'Как подключить рекламные площадки',
    onboarding: ConnectionsOnboarding,
    targetRoute (getters) {
      return {
        name: 'connectionsList',
        params: {
          accountId: getters.firstAccountId
        }
      };
    },
    requiredParams: ['firstAccountId']
  }
];

const onboardingAbortController = new AbortController();

const onboardingStore = {
  namespaced: true,
  state: {
    isOpen: false,
    isLoading: false,

    firstAccountId: null,
    accountProjectId: null,
    accountIdWithProject: null,

    // determine open new tab for onboardings or run in current
    runInNewTab: true
  },
  getters: {
    isMenuOpen: (state) => state.isOpen,
    isMenuLoading: (state) => state.isLoading,

    onboardingMenu (state, getters, rootState, rootGetters) {
      return rootGetters['user/userOnboardingMenu'];
    },
    showOnboardingMenu (state, getters) {
      return getters.onboardingMenu.show_menu;
    },
    onboardingMenuPosition (state, getters) {
      return getters.onboardingMenu.position;
    },
    filteredOnboardings (state, getters, rootState, rootGetters) {
      return MENU_ONBOARDINGS_LIST.filter(o => {
        if (!o.requiredParams) {
          return true;
        }
        return o.requiredParams.every(i => Boolean(getters[i]));
      }).map(i => ({
        ...i,
        isSeen: rootGetters['releaseNotes/onboardingIsSeen'](i.onboarding.name),

        // target rounte can be function to format with params from store
        targetRoute: typeof i.targetRoute === 'function' ? i.targetRoute(getters) : i.targetRoute
      }));
    },

    viewedOnboardingsCount (state, getters) {
      return getters.filteredOnboardings.reduce((acc, item) => {
        if (item.isSeen) {
          return acc + 1;
        }
        return acc;
      }, 0);
    },
    allOnboardingsViewd (state, getters) {
      return getters.viewedOnboardingsCount === getters.filteredOnboardings.length;
    },

    // required params to run onboardings
    firstAccountId (state, getters, rootState, rootGetters) {
      const accounts = rootGetters['sidebar/sidebarRootAccounts'];
      if (accounts.length > 0){
        return accounts[0].id;
      }
    },
    accountIdWithProject: state => state.accountIdWithProject,
    accountProjectId: state => state.accountProjectId,
    runInNewTab: state => state.runInNewTab
  },
  mutations: {
    TOGGLE_OPEN (state, open) {
      state.isOpen = open;
    },
    SET_LOADING (state, loading) {
      state.isLoading = loading;
    },
    SET_ACCOUNT_ID_WITH_PROJECT (state, accountId) {
      state.accountIdWithProject = accountId;
    },
    SET_ACCOUNT_PROJECT_ID (state, projectId) {
      state.accountProjectId = projectId;
    },
    SET_RUN_IN_NEW_TAB (state, runInNewTab) {
      state.runInNewTab = runInNewTab;
    }
  },
  actions: {
    async LOAD_STATE (context) {
      context.commit('SET_LOADING', true);

      await context.dispatch('FIND_ACCOUNT_WITH_PROJECT');

      context.commit('SET_LOADING', false);
    },
    async FIND_ACCOUNT_WITH_PROJECT (context) {
      const rootAccounts = context.rootGetters['sidebar/sidebarRootAccounts'];

      let project = null;
      for (let account of rootAccounts){
        if (project) {
          break;
        }

        const accountId = account.id;
        // eslint-disable-next-line no-await-in-loop
        const projects = (await projectsService.getAccountProjectsListSimple(
          accountId,
          {status: 'ACTIVE'},
          {signal: onboardingAbortController.signal}
        )).items;

        if (projects.length > 0) {
          project = projects[0];
        }
      }

      if (project) {
        context.commit('SET_ACCOUNT_PROJECT_ID', project.id);
        context.commit('SET_ACCOUNT_ID_WITH_PROJECT', project.account_id);
      }
    },
    async TOGGLE_MENU_SHOW (context, show) {
      const newState = {...context.getters.onboardingMenu};
      newState.show_menu = show;
      await context.dispatch('user/SET_ONBOARDING_MENU_STATE', newState, {root: true});
    },
    async MENU_UPDATE_POSITION (context, newPosition) {
      const newState = {...context.getters.onboardingMenu};
      newState.position = newPosition;
      await context.dispatch('user/SET_ONBOARDING_MENU_STATE', newState, {root: true});
    },
    async TOGGLE_MENU_OPEN (context, open) {
      context.commit('TOGGLE_OPEN', open);
    },
    SET_RUN_IN_NEW_TAB (context, runInNewTab) {
      context.commit('SET_RUN_IN_NEW_TAB', runInNewTab);
    }
  }
};

export default onboardingStore;
